// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-1q9RH","address_list":"address_list-32xgL","available_region_title":"available_region_title-28_XW","region_list":"region_list-2I0on","region":"region-Nyci3"};